export default {"src":"/_next/static/media/mir.3cd2b9e3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};